import type { TilePositionXY } from "./TilePositionXY.type"

export type TilePositionMinMax = {
  minX: number,
  maxX: number,
  minY: number,
  maxY: number,
}

export default function getTilePositionMinMax(
  arr: Array<TilePositionXY>
): TilePositionMinMax {
  if (arr.length === 0) {
    throw new Error("Array must not be empty")
  }

  let minX = arr[0].x
  let maxX = arr[0].x
  let minY = arr[0].y
  let maxY = arr[0].y

  for (let i = 1; i < arr.length; i++) {
    const { x, y } = arr[i]

    if (x < minX) minX = x
    if (x > maxX) maxX = x
    if (y < minY) minY = y
    if (y > maxY) maxY = y
  }

  return { minX, maxX, minY, maxY }
}